/** The number of rows a wrapping row of items takes up, placing each on the current row while it fits. */
function countRows(itemWidths: number[], containerWidth: number, gap: number): number {
  let rows = 0
  let rowWidth = 0
  for (const itemWidth of itemWidths) {
    // An item wider than the container shrinks to fit it
    const width = Math.min(itemWidth, containerWidth)
    if (rows > 0 && rowWidth + gap + width <= containerWidth) {
      rowWidth += gap + width
    } else {
      rows += 1
      rowWidth = width
    }
  }
  return rows
}

/**
 * How many chips fit in a wrapping row capped at `maxRows`. When they don't all fit, the count leaves room for an
 * overflow trigger after the last visible chip. Chips stay in order, so one that needs a row to itself can leave a row
 * empty rather than let a later, shorter chip move ahead of it.
 */
export function getVisibleChipCount({
  chipWidths,
  triggerWidth,
  containerWidth,
  gap,
  maxRows,
}: {
  chipWidths: number[]
  triggerWidth: number
  containerWidth: number
  gap: number
  maxRows: number
}): number {
  if (countRows(chipWidths, containerWidth, gap) <= maxRows) return chipWidths.length

  for (let count = chipWidths.length - 1; count > 0; count--) {
    if (countRows([...chipWidths.slice(0, count), triggerWidth], containerWidth, gap) <= maxRows) return count
  }
  return 0
}
